// import React, { useState } from "react";
// import "./MyAccount.css";

// const Addresses = () => {
//   const [addresses, setAddresses] = useState([
//     {
//       id: 1,
//       name: "John Doe",
//       phone: "+91 98765 43210",
//       addressLine1: "123 Main Street",
//       addressLine2: "Apartment 4B",
//       city: "Mumbai",
//       state: "Maharashtra",
//       pincode: "400001",
//       isDefault: true,
//       type: "Home",
//     },
//     {
//       id: 2,
//       name: "John Doe",
//       phone: "+91 98765 43210",
//       addressLine1: "456 Business Park",
//       addressLine2: "Floor 3",
//       city: "Pune",
//       state: "Maharashtra",
//       pincode: "411001",
//       isDefault: false,
//       type: "Office",
//     },
//   ]);

//   const [showModal, setShowModal] = useState(false);
//   const [editingAddress, setEditingAddress] = useState(null);
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     addressLine1: "",
//     addressLine2: "",
//     city: "",
//     state: "",
//     pincode: "",
//     type: "Home",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleAddAddress = () => {
//     setEditingAddress(null);
//     setFormData({
//       name: "",
//       phone: "",
//       addressLine1: "",
//       addressLine2: "",
//       city: "",
//       state: "",
//       pincode: "",
//       type: "Home",
//     });
//     setShowModal(true);
//   };

//   const handleEditAddress = (address) => {
//     setEditingAddress(address);
//     setFormData({
//       name: address.name,
//       phone: address.phone,
//       addressLine1: address.addressLine1,
//       addressLine2: address.addressLine2,
//       city: address.city,
//       state: address.state,
//       pincode: address.pincode,
//       type: address.type,
//     });
//     setShowModal(true);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (editingAddress) {
//       // Update existing address
//       setAddresses(
//         addresses.map((addr) =>
//           addr.id === editingAddress.id ? { ...addr, ...formData } : addr
//         )
//       );
//     } else {
//       // Add new address
//       const newAddress = {
//         id: addresses.length + 1,
//         ...formData,
//         isDefault: addresses.length === 0,
//       };
//       setAddresses([...addresses, newAddress]);
//     }
//     setShowModal(false);
//   };

//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this address?")) {
//       setAddresses(addresses.filter((addr) => addr.id !== id));
//     }
//   };

//   const handleSetDefault = (id) => {
//     setAddresses(
//       addresses.map((addr) => ({
//         ...addr,
//         isDefault: addr.id === id,
//       }))
//     );
//   };

//   return (
//     <div className="addresses-section">
//       <div className="section-header">
//         <div>
//           <h2 className="section-title">Saved Addresses</h2>
//           <p className="section-subtitle">Manage your delivery addresses</p>
//         </div>
//         <button
//           className="btn-primary add-address-btn"
//           onClick={handleAddAddress}
//         >
//           <svg
//             width="20"
//             height="20"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//           >
//             <line x1="12" y1="5" x2="12" y2="19" />
//             <line x1="5" y1="12" x2="19" y2="12" />
//           </svg>
//           Add New Address
//         </button>
//       </div>

//       {/* Addresses Grid */}
//       <div className="addresses-grid">
//         {addresses.length > 0 ? (
//           addresses.map((address) => (
//             <div key={address.id} className="address-card">
//               {address.isDefault && (
//                 <span className="default-badge">Default</span>
//               )}
//               <div className="address-type">
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   {address.type === "Home" ? (
//                     <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
//                   ) : (
//                     <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
//                   )}
//                 </svg>
//                 <span>{address.type}</span>
//               </div>
//               <h3 className="address-name">{address.name}</h3>
//               <p className="address-phone">{address.phone}</p>
//               <div className="address-details">
//                 <p>{address.addressLine1}</p>
//                 {address.addressLine2 && <p>{address.addressLine2}</p>}
//                 <p>
//                   {address.city}, {address.state} - {address.pincode}
//                 </p>
//               </div>
//               <div className="address-actions">
//                 <button
//                   className="action-btn edit-btn"
//                   onClick={() => handleEditAddress(address)}
//                 >
//                   <svg
//                     width="18"
//                     height="18"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                     <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                   </svg>
//                   Edit
//                 </button>
//                 <button
//                   className="action-btn delete-btn"
//                   onClick={() => handleDelete(address.id)}
//                 >
//                   <svg
//                     width="18"
//                     height="18"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="3 6 5 6 21 6" />
//                     <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
//                   </svg>
//                   Delete
//                 </button>
//                 {!address.isDefault && (
//                   <button
//                     className="action-btn default-btn"
//                     onClick={() => handleSetDefault(address.id)}
//                   >
//                     Set as Default
//                   </button>
//                 )}
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="no-addresses">
//             <svg
//               width="80"
//               height="80"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="1.5"
//             >
//               <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
//               <circle cx="12" cy="10" r="3" />
//             </svg>
//             <h3>No addresses saved</h3>
//             <p>Add your first delivery address</p>
//             <button className="btn-primary" onClick={handleAddAddress}>
//               Add Address
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Address Modal */}
//       {showModal && (
//         <div className="modal-overlay" onClick={() => setShowModal(false)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3 className="modal-title">
//                 {editingAddress ? "Edit Address" : "Add New Address"}
//               </h3>
//               <button
//                 className="modal-close"
//                 onClick={() => setShowModal(false)}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <line x1="18" y1="6" x2="6" y2="18" />
//                   <line x1="6" y1="6" x2="18" y2="18" />
//                 </svg>
//               </button>
//             </div>

//             <form onSubmit={handleSubmit} className="address-form">
//               <div className="form-grid">
//                 <div className="form-group">
//                   <label htmlFor="name" className="form-label">
//                     Full Name *
//                   </label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="phone" className="form-label">
//                     Phone Number *
//                   </label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group full-width">
//                   <label htmlFor="addressLine1" className="form-label">
//                     Address Line 1 *
//                   </label>
//                   <input
//                     type="text"
//                     id="addressLine1"
//                     name="addressLine1"
//                     value={formData.addressLine1}
//                     onChange={handleChange}
//                     className="form-input"
//                     placeholder="House No., Building Name"
//                     required
//                   />
//                 </div>

//                 <div className="form-group full-width">
//                   <label htmlFor="addressLine2" className="form-label">
//                     Address Line 2
//                   </label>
//                   <input
//                     type="text"
//                     id="addressLine2"
//                     name="addressLine2"
//                     value={formData.addressLine2}
//                     onChange={handleChange}
//                     className="form-input"
//                     placeholder="Road Name, Area, Colony"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="city" className="form-label">
//                     City *
//                   </label>
//                   <input
//                     type="text"
//                     id="city"
//                     name="city"
//                     value={formData.city}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="state" className="form-label">
//                     State *
//                   </label>
//                   <input
//                     type="text"
//                     id="state"
//                     name="state"
//                     value={formData.state}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="pincode" className="form-label">
//                     Pincode *
//                   </label>
//                   <input
//                     type="text"
//                     id="pincode"
//                     name="pincode"
//                     value={formData.pincode}
//                     onChange={handleChange}
//                     className="form-input"
//                     pattern="[0-9]{6}"
//                     maxLength="6"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="type" className="form-label">
//                     Address Type *
//                   </label>
//                   <select
//                     id="type"
//                     name="type"
//                     value={formData.type}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   >
//                     <option value="Home">Home</option>
//                     <option value="Office">Office</option>
//                     <option value="Other">Other</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="modal-actions">
//                 <button type="submit" className="btn-primary">
//                   {editingAddress ? "Update Address" : "Save Address"}
//                 </button>
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Addresses;

import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Space,
  Card,
  Tag,
  Popconfirm,
  Radio,
  Row,
  Col,
  Empty,
  Spin,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  HomeOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import addressService from "../../services/addressService";
import { toast } from "react-toastify";
import "./AddressManagement.css";

const { Option } = Select;

const AddressManagement = ({ onSelectAddress, selectionMode = false }) => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [form] = Form.useForm();

  // Indian states
  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Delhi",
  ];

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    try {
      setLoading(true);
      const response = await addressService.getAddresses();

      if (response?.success) {
        setAddresses(response.data);

        // Auto-select default address if in selection mode
        if (selectionMode) {
          const defaultAddr = response.data.find((addr) => addr.isDefault);
          if (defaultAddr) {
            setSelectedAddressId(defaultAddr._id);
            onSelectAddress?.(defaultAddr);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
      toast.error("Failed to fetch addresses");
    } finally {
      setLoading(false);
    }
  };

  const handleAddNew = () => {
    setEditingAddress(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (address) => {
    setEditingAddress(address);
    form.setFieldsValue(address);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      const response = await addressService.deleteAddress(id);

      if (response?.success) {
        toast.success("Address deleted successfully");
        fetchAddresses();
      }
    } catch (error) {
      console.error("Error deleting address:", error);
      toast.error(error?.response?.data?.message || "Failed to delete address");
    }
  };

  const handleSetDefault = async (id) => {
    try {
      const response = await addressService.setDefaultAddress(id);

      if (response?.success) {
        toast.success("Default address updated");
        fetchAddresses();
      }
    } catch (error) {
      console.error("Error setting default address:", error);
      toast.error("Failed to set default address");
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      let response;
      if (editingAddress) {
        response = await addressService.updateAddress(
          editingAddress._id,
          values
        );
      } else {
        response = await addressService.createAddress(values);
      }

      if (response?.success) {
        toast.success(
          editingAddress
            ? "Address updated successfully"
            : "Address added successfully"
        );
        setModalVisible(false);
        form.resetFields();
        fetchAddresses();
      }
    } catch (error) {
      console.error("Error saving address:", error);
      toast.error(error?.response?.data?.message || "Failed to save address");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAddress = (address) => {
    setSelectedAddressId(address._id);
    onSelectAddress?.(address);
  };

  return (
    <div className="address-management">
      <div className="address-header">
        <h2>My Addresses</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
          Add your Address
        </Button>
      </div>

      {loading && addresses.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Spin size="large" />
        </div>
      ) : addresses.length === 0 ? (
        <Empty
          description="No addresses found"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        >
          <Button type="primary" onClick={handleAddNew}>
            Add Your Address
          </Button>
        </Empty>
      ) : (
        <Row gutter={[16, 16]}>
          {addresses.map((address) => (
            <Col xs={24} sm={12} lg={8} key={address._id}>
              <Card
                className={`address-card ${
                  selectionMode && selectedAddressId === address._id
                    ? "selected"
                    : ""
                }`}
                onClick={() => selectionMode && handleSelectAddress(address)}
                style={{ cursor: selectionMode ? "pointer" : "default" }}
              >
                <div className="address-card-header">
                  <div className="address-type">
                    <HomeOutlined />
                    <span>{address.addressType}</span>
                  </div>
                  {address.isDefault && (
                    <Tag color="green" icon={<CheckCircleOutlined />}>
                      Default
                    </Tag>
                  )}
                  {selectionMode && selectedAddressId === address._id && (
                    <CheckCircleOutlined
                      style={{ fontSize: "24px", color: "#52c41a" }}
                    />
                  )}
                </div>

                <div className="address-details">
                  <h4>{address.name}</h4>
                  <p>{address.addressLine1}</p>
                  {address.addressLine2 && <p>{address.addressLine2}</p>}
                  {address.landmark && <p>Landmark: {address.landmark}</p>}
                  <p>
                    {address.city}, {address.state} - {address.pincode}
                  </p>
                  <p className="address-mobile">Mobile: {address.mobile}</p>
                </div>

                {!selectionMode && (
                  <div className="address-actions">
                    <Space>
                      <Button
                        type="text"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(address)}
                      >
                        Edit
                      </Button>
                      <Popconfirm
                        title="Delete Address"
                        description="Are you sure you want to delete this address?"
                        onConfirm={() => handleDelete(address._id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="text" danger icon={<DeleteOutlined />}>
                          Delete
                        </Button>
                      </Popconfirm>
                      {!address.isDefault && (
                        <Button
                          type="link"
                          onClick={() => handleSetDefault(address._id)}
                        >
                          Set as Default
                        </Button>
                      )}
                    </Space>
                  </div>
                )}
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {/* Add/Edit Address Modal */}
      <Modal
        title={editingAddress ? "Edit Address" : "Add New Address"}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            addressType: "Home",
            country: "India",
            isDefault: false,
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Full Name"
                rules={[{ required: true, message: "Please enter your name" }]}
              >
                <Input placeholder="Enter full name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="mobile"
                label="Mobile Number"
                rules={[
                  { required: true, message: "Please enter mobile number" },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Please enter valid 10-digit mobile number",
                  },
                ]}
              >
                <Input placeholder="10-digit mobile number" maxLength={10} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="addressLine1"
            label="Address Line 1"
            rules={[{ required: true, message: "Please enter address line 1" }]}
          >
            <Input placeholder="House No, Building Name" />
          </Form.Item>

          <Form.Item name="addressLine2" label="Address Line 2">
            <Input placeholder="Road Name, Area, Colony" />
          </Form.Item>

          <Form.Item name="landmark" label="Landmark">
            <Input placeholder="Nearby landmark (optional)" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="city"
                label="City"
                rules={[{ required: true, message: "Please enter city" }]}
              >
                <Input placeholder="City" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="state"
                label="State"
                rules={[{ required: true, message: "Please select state" }]}
              >
                <Select placeholder="Select State" showSearch>
                  {indianStates.map((state) => (
                    <Option key={state} value={state}>
                      {state}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="pincode"
                label="Pincode"
                rules={[
                  { required: true, message: "Please enter pincode" },
                  {
                    pattern: /^[0-9]{6}$/,
                    message: "Please enter valid 6-digit pincode",
                  },
                ]}
              >
                <Input placeholder="6-digit pincode" maxLength={6} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="addressType" label="Address Type">
                <Select>
                  <Option value="Home">Home</Option>
                  <Option value="Work">Work</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="isDefault" valuePropName="checked">
            <Radio.Group>
              <Radio value={true}>Set as default address</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                {editingAddress ? "Update Address" : "Save Address"}
              </Button>
              <Button onClick={() => setModalVisible(false)}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddressManagement;
